import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "heading"];
import PropTypes from 'prop-types';
import React, { cloneElement, forwardRef } from 'react';
import { Flex } from '../Flex/Flex';
import { StyledPageTitle } from './PageTitle.styles';

/**
 * The page title is used for the primary heading of the page, typically an `<h1>`.
 *
 * For cross-page consistency, the heading style is fixed, but you can still change the underlying
 * element with the `level` prop on `Heading`. If for some reason you need a different style,
 * you can simply use a `Heading` with the generic `PageContent` component.
 *
 * @related ['Heading']
 * @extends PageContent
 * @since 8.15.0
 */
export var PageTitle = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
    heading = _ref.heading,
    rest = _objectWithoutProperties(_ref, _excluded);
  var headingClone = /*#__PURE__*/cloneElement(heading, {
    fontType: 'h3',
    fontFamily: 'serif'
  });
  return /*#__PURE__*/React.createElement(StyledPageTitle, _extends({
    ref: forwardedRef
  }, rest), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Flex, null, headingClone), /*#__PURE__*/React.createElement(Flex, null, children)));
});
PageTitle.displayName = 'PageTitle';
PageTitle.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Children content will be flexed to the end of the title row.
   */
  children: PropTypes.node,
  /**
   * A `Heading` component, typically
   * with `level={1}`. Note: `fontType` and `fontFamily` are fixed for this component for
   * consistent styles across pages.
   */
  heading: PropTypes.node.isRequired
} : {};